import { PermissionCode, UserType } from '@shared/common/enums';
import { NavigationItem } from './navigation-item.interface';
import { BadgeKey } from '../../common/enums';

export const NAVIGATION_MENU: NavigationItem[] = [
    {
        type: 'link',
        label: 'Dashboard',
        route: '/',
        icon: 'dashboard',
        routerLinkActiveOptions: { exact: true },
    },
    {
        type: 'subheading',
        label: 'User Management',
        permissions: [
            PermissionCode.CREATE_USER,
            PermissionCode.UPDATE_USER,
            PermissionCode.DELETE_USER,
            PermissionCode.VIEW_USER,
            PermissionCode.DISABLE_ENABLE_USER,
            PermissionCode.RESET_USER_PASSWORD,
            PermissionCode.VIEW_CUSTOMER,
            PermissionCode.CREATE_CUSTOMER,
            PermissionCode.DELETE_CUSTOMER,
            PermissionCode.UPDATE_CUSTOMER,
            PermissionCode.DISABLE_ENABLE_CUSTOMER,
            PermissionCode.RESET_CUSTOMER_PASSWORD,
            PermissionCode.VIEW_SUB_AGENT,
            PermissionCode.CREATE_SUB_AGENT,
            PermissionCode.DELETE_SUB_AGENT,
            PermissionCode.UPDATE_SUB_AGENT,
            PermissionCode.DISABLE_ENABLE_SUB_AGENT,
            PermissionCode.RESET_SUB_AGENT_PASSWORD,
            PermissionCode.VIEW_WHITELABEL,
            PermissionCode.CREATE_WHITELABEL,
            PermissionCode.DELETE_WHITELABEL,
            PermissionCode.UPDATE_WHITELABEL,
            PermissionCode.DISABLE_ENABLE_WHITELABEL,
            PermissionCode.RESET_WHITELABEL_PASSWORD,
        ],
        children: [
            {
                type: 'dropdown',
                label: 'Users',
                icon: 'person',
                permissions: [
                    PermissionCode.CREATE_USER,
                    PermissionCode.UPDATE_USER,
                    PermissionCode.DELETE_USER,
                    PermissionCode.VIEW_USER,
                    PermissionCode.DISABLE_ENABLE_USER,
                    PermissionCode.RESET_USER_PASSWORD,
                    PermissionCode.VIEW_CUSTOMER,
                    PermissionCode.CREATE_CUSTOMER,
                    PermissionCode.DELETE_CUSTOMER,
                    PermissionCode.UPDATE_CUSTOMER,
                    PermissionCode.DISABLE_ENABLE_CUSTOMER,
                    PermissionCode.RESET_CUSTOMER_PASSWORD,
                    PermissionCode.VIEW_SUB_AGENT,
                    PermissionCode.CREATE_SUB_AGENT,
                    PermissionCode.DELETE_SUB_AGENT,
                    PermissionCode.UPDATE_SUB_AGENT,
                    PermissionCode.DISABLE_ENABLE_SUB_AGENT,
                    PermissionCode.RESET_SUB_AGENT_PASSWORD,
                    PermissionCode.VIEW_WHITELABEL,
                    PermissionCode.CREATE_WHITELABEL,
                    PermissionCode.DELETE_WHITELABEL,
                    PermissionCode.UPDATE_WHITELABEL,
                    PermissionCode.DISABLE_ENABLE_WHITELABEL,
                    PermissionCode.RESET_WHITELABEL_PASSWORD,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Administrators',
                        route: '/users/admin',
                        icon: 'shield_person',
                        permissions: [
                            PermissionCode.CREATE_USER,
                            PermissionCode.UPDATE_USER,
                            PermissionCode.DELETE_USER,
                            PermissionCode.VIEW_USER,
                            PermissionCode.DISABLE_ENABLE_USER,
                            PermissionCode.RESET_USER_PASSWORD,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygnal Rewards',
                        userTypes: [UserType.ADMIN],
                        route: '/users/customer',
                        permissions: [
                            PermissionCode.VIEW_CUSTOMER,
                            PermissionCode.CREATE_CUSTOMER,
                            PermissionCode.DELETE_CUSTOMER,
                            PermissionCode.UPDATE_CUSTOMER,
                            PermissionCode.DISABLE_ENABLE_CUSTOMER,
                            PermissionCode.RESET_CUSTOMER_PASSWORD,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygates Agents',
                        route: '/users/sub-agents/agent',
                        userTypes: [UserType.WHITELABEL, UserType.ADMIN],
                        permissions: [
                            PermissionCode.VIEW_SUB_AGENT,
                            PermissionCode.CREATE_SUB_AGENT,
                            PermissionCode.DELETE_SUB_AGENT,
                            PermissionCode.UPDATE_SUB_AGENT,
                            PermissionCode.DISABLE_ENABLE_SUB_AGENT,
                            PermissionCode.RESET_SUB_AGENT_PASSWORD,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygates Whitelabel',
                        route: '/users/sub-agents/whitelabel',
                        userTypes: [UserType.ADMIN],
                        permissions: [
                            PermissionCode.VIEW_WHITELABEL,
                            PermissionCode.CREATE_WHITELABEL,
                            PermissionCode.DELETE_WHITELABEL,
                            PermissionCode.UPDATE_WHITELABEL,
                            PermissionCode.DISABLE_ENABLE_WHITELABEL,
                            PermissionCode.RESET_WHITELABEL_PASSWORD,
                        ],
                    },
                ],
            },
            {
                type: 'link',
                label: 'Merchants',
                icon: 'storefront',
                route: '/merchants/all',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_MERCHANT,
                    PermissionCode.CREATE_MERCHANT,
                    PermissionCode.UPDATE_MERCHANT,
                    PermissionCode.DISABLE_ENABLE_MERCHANT,
                    PermissionCode.MANAGE_MERCHANT_DOCUMENT,
                    PermissionCode.MERCHANT_ACCEPTING_PAYMENTS,
                ],
            },
            {
                type: 'dropdown',
                label: 'User Groups',
                icon: 'groups',
                permissions: [
                    PermissionCode.VIEW_USER_ROLE,
                    PermissionCode.UPDATE_USER_ROLE,
                    PermissionCode.DELETE_USER_ROLE,
                    PermissionCode.CREATE_USER_ROLE,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Administrators',
                        route: '/user-groups/admin',
                        icon: 'shield_person',
                        permissions: [
                            PermissionCode.VIEW_USER_ROLE,
                            PermissionCode.CREATE_USER_ROLE,
                            PermissionCode.UPDATE_USER_ROLE,
                            PermissionCode.DELETE_USER_ROLE,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygnal Rewards',
                        route: '/user-groups/customer',
                        userTypes: [UserType.ADMIN],
                        permissions: [
                            PermissionCode.VIEW_USER_ROLE,
                            PermissionCode.CREATE_USER_ROLE,
                            PermissionCode.UPDATE_USER_ROLE,
                            PermissionCode.DELETE_USER_ROLE,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygates Whitelabel',
                        route: '/user-groups/whitelabel',
                        userTypes: [UserType.ADMIN],
                        permissions: [
                            PermissionCode.VIEW_USER_ROLE,
                            PermissionCode.CREATE_USER_ROLE,
                            PermissionCode.UPDATE_USER_ROLE,
                            PermissionCode.DELETE_USER_ROLE,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Cygates Agents',
                        route: '/user-groups/agent',
                        userTypes: [UserType.ADMIN, UserType.WHITELABEL],
                        permissions: [
                            PermissionCode.VIEW_USER_ROLE,
                            PermissionCode.CREATE_USER_ROLE,
                            PermissionCode.UPDATE_USER_ROLE,
                            PermissionCode.DELETE_USER_ROLE,
                        ],
                    },
                ],
            },
            {
                type: 'link',
                label: `Customer's KYC`,
                route: '/kyc/all',
                icon: 'id_card',
                permissions: [
                    PermissionCode.VIEW_KYC_APPLICATION,
                    PermissionCode.REVIEW_KYC_APPLICATION,
                ],
                userTypes: [UserType.ADMIN],
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_KYC_APPLICATION,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
            },
            {
                type: 'link',
                label: 'User APIs',
                route: '/user-api',
                icon: 'key',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_USER_API_KEY,
                    PermissionCode.CREATE_USER_API_KEY,
                    PermissionCode.DELETE_USER_API_KEY,
                    PermissionCode.UPDATE_USER_API_KEY,
                ],
            },
            {
                type: 'dropdown',
                label: 'NFC Cards',
                icon: 'nfc',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_NFC_CARD,
                    PermissionCode.REGISTER_NFC_CARD,
                    PermissionCode.VIEW_NFC_WRITE_HISTORY,
                    PermissionCode.CREATE_NFC_WRITE_HISTORY,
                    PermissionCode.VIEW_NFC_CARD_REQUEST,
                    PermissionCode.REVIEW_NFC_CARD_REQUEST,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Card Management',
                        route: '/nfc-management/cards',
                        permissions: [PermissionCode.VIEW_NFC_CARD],
                    },
                    {
                        type: 'link',
                        label: 'Card Writer',
                        route: '/nfc-management',
                        permissions: [
                            PermissionCode.VIEW_NFC_WRITE_HISTORY,
                            PermissionCode.CREATE_NFC_WRITE_HISTORY,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Card Requests',
                        route: '/nfc-card-requests/NEW',
                        permissions: [
                            PermissionCode.VIEW_NFC_CARD_REQUEST,
                            PermissionCode.REVIEW_NFC_CARD_REQUEST,
                        ],
                        badge: {
                            value: 0,
                            key: BadgeKey.NEW_NFC_CARD_REQUEST,
                            bgClass: 'bg-danger',
                            textClass: 'text-white',
                        },
                    },
                ],
            },
        ],
    },
    {
        type: 'subheading',
        label: 'Booking Requests',
        children: [
            {
                type: 'link',
                label: 'Visa',
                route: '/visa-application',
                icon: 'support',
                badge: {
                    value: 10,
                    key: BadgeKey.NEW_VISA_APPLICATION,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                userTypes: [UserType.ADMIN, UserType.AGENT],
                permissions: [
                    PermissionCode.VIEW_VISA_APPLICATION,
                    PermissionCode.CREATE_VISA_APPLICATION,
                    PermissionCode.RESUBMIT_VISA_FILE_REQUIREMENTS,
                    PermissionCode.REVIEW_VISA_FILE_REQUIREMENTS,
                    PermissionCode.CHANGE_STATUS_VISA_APPLICATION,
                ],
            },
            {
                type: 'link',
                label: 'Driving Permit',
                route: '/driving-permit-application',
                icon: 'badge',
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_DRIVING_PERMIT_APPLICATION,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                userTypes: [UserType.ADMIN, UserType.AGENT],
                permissions: [
                    PermissionCode.VIEW_DRIVING_PERMIT_APPLICATION,
                    PermissionCode.CREATE_DRIVING_PERMIT_APPLICATION,
                    PermissionCode.RESUBMIT_DRIVING_PERMIT_FILE_REQUIREMENTS,
                    PermissionCode.REVIEW_DRIVING_PERMIT_FILE_REQUIREMENTS,
                    PermissionCode.CHANGE_STATUS_DRIVING_PERMIT_APPLICATION,
                ],
            },
            {
                type: 'link',
                label: 'Passport',
                route: '/passport-application/list',
                icon: 'support',
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_PASSPORT_APPLICATION,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                userTypes: [UserType.ADMIN, UserType.AGENT],
                permissions: [
                    PermissionCode.VIEW_PASSPORT_APPLICATION,
                    PermissionCode.CREATE_PASSPORT_APPLICATION,
                    PermissionCode.RESUBMIT_PASSPORT_DOCUMENTS,
                ],
            },
            {
                type: 'link',
                label: 'Travel Insurance',
                route: '/manual-booking/travel-insurance/applications/list',
                icon: 'shield',
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_TRAVEL_INSURANCE_APPLICATION,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                userTypes: [UserType.ADMIN, UserType.AGENT],
                permissions: [
                    PermissionCode.VIEW_TRAVEL_INSURANCE_APPLICATION,
                    PermissionCode.CREATE_TRAVEL_INSURANCE_APPLICATION,
                    PermissionCode.CHANGE_STATUS_TRAVEL_INSURANCE_APPLICATION,
                ],
            },
            {
                type: 'link',
                label: 'Travel Package',
                route: '/travel-bookings',
                icon: 'luggage',
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_TOUR_PACKAGE_BOOKING,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                permissions: [
                    PermissionCode.VIEW_TOUR_PACKAGE_BOOKING,
                    PermissionCode.UPDATE_TOUR_PACKAGE_BOOKING_STATUS,
                    PermissionCode.CANCEL_TOUR_PACKAGE_BOOKING,
                ],
            },
            {
                type: 'link',
                label: 'Chat Support',
                route: '/chat',
                icon: 'support',
                badge: {
                    value: 12,
                    key: BadgeKey.UNREAD_CHAT,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
                permissions: [PermissionCode.VIEW_CHAT_SUPPORT],
                userTypes: [UserType.ADMIN, UserType.AGENT, UserType.WHITELABEL],
            },
        ],
    },

    {
        type: 'subheading',
        label: 'Fundings',
        children: [
            {
                type: 'link',
                label: 'Risk Review',
                route: '/risk-review',
                icon: 'gpp_maybe',
                permissions: [PermissionCode.VIEW_RISK_REVIEW],
            },
            {
                type: 'link',
                label: 'Fund Request',
                route: '/fund-request/all',
                icon: 'add_card',
                permissions: [
                    PermissionCode.VIEW_FUND_REQUEST,
                    PermissionCode.CREATE_FUND_REQUEST,
                    PermissionCode.REVIEW_FUND_REQUEST,
                ],
                badge: {
                    value: 0,
                    key: BadgeKey.NEW_FUND_REQUEST,
                    bgClass: 'bg-danger',
                    textClass: 'text-white',
                },
            },
            {
                type: 'link',
                label: 'Fund Manual',
                route: '/fund-manual',
                icon: 'checkbook',
                permissions: [
                    PermissionCode.VIEW_MANUAL_FUND,
                    PermissionCode.DEBIT_MANUAL_FUND,
                    PermissionCode.CREDIT_MANUAL_FUND,
                ],
            },
        ],
    },
    {
        type: 'subheading',
        label: 'Transaction Reports',
        permissions: [
            PermissionCode.VIEW_MANUAL_FUND,
            PermissionCode.VIEW_FLIGHT_BOOKING,
            PermissionCode.VIEW_HOTEL_BOOKING,
        ],
        children: [
            {
                type: 'link',
                label: 'Transactions',
                route: '/ewallet-transactions/all',
                icon: 'support',
                permissions: [PermissionCode.VIEW_MANUAL_FUND],
            },

            {
                type: 'link',
                label: 'Flight Bookings',
                route: '/flight-bookings',
                icon: 'flight',
                permissions: [PermissionCode.VIEW_FLIGHT_BOOKING],
            },
            {
                type: 'link',
                label: 'Hotel Bookings',
                route: '/hotel-bookings',
                icon: 'bed',
                permissions: [PermissionCode.VIEW_HOTEL_BOOKING],
            },
        ],
    },
    {
        type: 'subheading',
        label: 'Accounting',
        permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
        children: [
            {
                type: 'link',
                label: 'Overview',
                route: '/accounting',
                icon: 'receipt_long',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
                routerLinkActiveOptions: { exact: true },
            },
            {
                type: 'link',
                label: 'Money Flow',
                route: '/accounting/money-flow',
                icon: 'swap_horiz',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
            },
            {
                type: 'link',
                label: 'P&L Statement',
                route: '/accounting/income-statement',
                icon: 'trending_up',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
            },
            {
                type: 'link',
                label: 'Subscribers',
                route: '/accounting/subscribers',
                icon: 'groups',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
            },
            {
                type: 'link',
                label: 'Cash & Liability',
                route: '/accounting/cash-liability',
                icon: 'account_balance',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
            },
            {
                type: 'link',
                label: 'General Ledger',
                route: '/accounting/ledger',
                icon: 'menu_book',
                permissions: [PermissionCode.VIEW_ACCOUNTING_REPORT],
            },
        ],
    },

    {
        type: 'subheading',
        label: 'Content Management',
        userTypes: [UserType.ADMIN],
        permissions: [
            PermissionCode.CREATE_VISA,
            PermissionCode.VIEW_VISA,
            PermissionCode.DELETE_VISA,
            PermissionCode.UPDATE_VISA,
            PermissionCode.CREATE_VISA_ACKNOWLEDGEMENT,
            PermissionCode.VIEW_VISA_ACKNOWLEDGEMENT,
            PermissionCode.DELETE_VISA_ACKNOWLEDGEMENT,
            PermissionCode.UPDATE_VISA_ACKNOWLEDGEMENT,
            PermissionCode.CREATE_VISA_FILE_REQUIREMENT,
            PermissionCode.VIEW_VISA_FILE_REQUIREMENT,
            PermissionCode.DELETE_VISA_FILE_REQUIREMENT,
            PermissionCode.UPDATE_VISA_FILE_REQUIREMENT,
            PermissionCode.CREATE_DRIVING_PERMIT,
            PermissionCode.VIEW_DRIVING_PERMIT,
            PermissionCode.DELETE_DRIVING_PERMIT,
            PermissionCode.UPDATE_DRIVING_PERMIT,
            PermissionCode.CREATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
            PermissionCode.VIEW_DRIVING_PERMIT_ACKNOWLEDGEMENT,
            PermissionCode.DELETE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
            PermissionCode.UPDATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
            PermissionCode.CREATE_DRIVING_PERMIT_FILE_REQUIREMENT,
            PermissionCode.VIEW_DRIVING_PERMIT_FILE_REQUIREMENT,
            PermissionCode.DELETE_DRIVING_PERMIT_FILE_REQUIREMENT,
            PermissionCode.UPDATE_DRIVING_PERMIT_FILE_REQUIREMENT,
            PermissionCode.VIEW_PASSPORT_APPLICATION_TYPE,
            PermissionCode.CREATE_PASSPORT_APPLICATION_TYPE,
            PermissionCode.UPDATE_PASSPORT_APPLICATION_TYPE,
            PermissionCode.DELETE_PASSPORT_APPLICATION_TYPE,
            PermissionCode.VIEW_PASSPORT_REQUIREMENT,
            PermissionCode.CREATE_PASSPORT_REQUIREMENT,
            PermissionCode.UPDATE_PASSPORT_REQUIREMENT,
            PermissionCode.DELETE_PASSPORT_REQUIREMENT,
            PermissionCode.VIEW_PASSPORT_ACKNOWLEDGEMENT,
            PermissionCode.CREATE_PASSPORT_ACKNOWLEDGEMENT,
            PermissionCode.UPDATE_PASSPORT_ACKNOWLEDGEMENT,
            PermissionCode.DELETE_PASSPORT_ACKNOWLEDGEMENT,
            PermissionCode.VIEW_PASSPORT_DFA_SITE,
            PermissionCode.CREATE_PASSPORT_DFA_SITE,
            PermissionCode.UPDATE_PASSPORT_DFA_SITE,
            PermissionCode.DELETE_PASSPORT_DFA_SITE,
            PermissionCode.VIEW_TOUR_PACKAGE,
            PermissionCode.CREATE_TOUR_PACKAGE,
            PermissionCode.UPDATE_TOUR_PACKAGE,
            PermissionCode.DELETE_TOUR_PACKAGE,
            PermissionCode.VIEW_TOUR_PACKAGE_BOOKING,
            PermissionCode.UPDATE_TOUR_PACKAGE_BOOKING_STATUS,
            PermissionCode.CANCEL_TOUR_PACKAGE_BOOKING,
        ],
        children: [
            {
                type: 'dropdown',
                label: 'Visa',
                icon: 'globe',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.CREATE_VISA,
                    PermissionCode.VIEW_VISA,
                    PermissionCode.DELETE_VISA,
                    PermissionCode.UPDATE_VISA,
                    PermissionCode.CREATE_VISA_ACKNOWLEDGEMENT,
                    PermissionCode.VIEW_VISA_ACKNOWLEDGEMENT,
                    PermissionCode.DELETE_VISA_ACKNOWLEDGEMENT,
                    PermissionCode.UPDATE_VISA_ACKNOWLEDGEMENT,
                    PermissionCode.CREATE_VISA_FILE_REQUIREMENT,
                    PermissionCode.VIEW_VISA_FILE_REQUIREMENT,
                    PermissionCode.DELETE_VISA_FILE_REQUIREMENT,
                    PermissionCode.UPDATE_VISA_FILE_REQUIREMENT,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Visa List',
                        route: '/visa-management/visa-list',
                        permissions: [
                            PermissionCode.CREATE_VISA,
                            PermissionCode.VIEW_VISA,
                            PermissionCode.DELETE_VISA,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Acknowledgements',
                        route: '/visa-management/acknowledgements',
                        permissions: [
                            PermissionCode.CREATE_VISA_ACKNOWLEDGEMENT,
                            PermissionCode.VIEW_VISA_ACKNOWLEDGEMENT,
                            PermissionCode.DELETE_VISA_ACKNOWLEDGEMENT,
                            PermissionCode.UPDATE_VISA_ACKNOWLEDGEMENT,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Requirements',
                        route: '/visa-management/requirements',
                        permissions: [
                            PermissionCode.CREATE_VISA_FILE_REQUIREMENT,
                            PermissionCode.VIEW_VISA_FILE_REQUIREMENT,
                            PermissionCode.DELETE_VISA_FILE_REQUIREMENT,
                            PermissionCode.UPDATE_VISA_FILE_REQUIREMENT,
                        ],
                    },
                ],
            },
            {
                type: 'dropdown',
                label: 'Manual Booking',
                icon: 'assignment_turned_in',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_TRAVEL_INSURANCE,
                    PermissionCode.CREATE_TRAVEL_INSURANCE,
                    PermissionCode.UPDATE_TRAVEL_INSURANCE,
                    PermissionCode.DELETE_TRAVEL_INSURANCE,
                    PermissionCode.VIEW_TRAVEL_INSURANCE_FILE_REQUIREMENT,
                    PermissionCode.VIEW_TRAVEL_INSURANCE_ACKNOWLEDGEMENT,
                    PermissionCode.VIEW_IMMIGRATION_SERVICE,
                    PermissionCode.CREATE_IMMIGRATION_SERVICE,
                    PermissionCode.UPDATE_IMMIGRATION_SERVICE,
                    PermissionCode.DELETE_IMMIGRATION_SERVICE,
                    PermissionCode.VIEW_IMMIGRATION_SERVICE_FILE_REQUIREMENT,
                    PermissionCode.VIEW_IMMIGRATION_SERVICE_ACKNOWLEDGEMENT,
                ],
                children: [
                    {
                        type: 'dropdown',
                        label: 'Travel Insurance',
                        icon: 'flight_takeoff',
                        permissions: [
                            PermissionCode.VIEW_TRAVEL_INSURANCE,
                            PermissionCode.CREATE_TRAVEL_INSURANCE,
                            PermissionCode.UPDATE_TRAVEL_INSURANCE,
                            PermissionCode.DELETE_TRAVEL_INSURANCE,
                            PermissionCode.VIEW_TRAVEL_INSURANCE_FILE_REQUIREMENT,
                            PermissionCode.VIEW_TRAVEL_INSURANCE_ACKNOWLEDGEMENT,
                        ],
                        children: [
                            {
                                type: 'link',
                                label: 'Service List',
                                route: '/manual-booking-management/travel-insurance/service-list',
                                permissions: [
                                    PermissionCode.VIEW_TRAVEL_INSURANCE,
                                ],
                            },
                            {
                                type: 'link',
                                label: 'File Requirements',
                                route: '/manual-booking-management/travel-insurance/file-requirements',
                                permissions: [
                                    PermissionCode.VIEW_TRAVEL_INSURANCE_FILE_REQUIREMENT,
                                ],
                            },
                            {
                                type: 'link',
                                label: 'Acknowledgements',
                                route: '/manual-booking-management/travel-insurance/acknowledgements',
                                permissions: [
                                    PermissionCode.VIEW_TRAVEL_INSURANCE_ACKNOWLEDGEMENT,
                                ],
                            },
                        ],
                    },
                    {
                        type: 'dropdown',
                        label: 'Immigration Service',
                        icon: 'badge',
                        permissions: [
                            PermissionCode.VIEW_IMMIGRATION_SERVICE,
                            PermissionCode.CREATE_IMMIGRATION_SERVICE,
                            PermissionCode.UPDATE_IMMIGRATION_SERVICE,
                            PermissionCode.DELETE_IMMIGRATION_SERVICE,
                            PermissionCode.VIEW_IMMIGRATION_SERVICE_FILE_REQUIREMENT,
                            PermissionCode.VIEW_IMMIGRATION_SERVICE_ACKNOWLEDGEMENT,
                        ],
                        children: [
                            {
                                type: 'link',
                                label: 'Service List',
                                route: '/manual-booking-management/immigration-service/service-list',
                                permissions: [
                                    PermissionCode.VIEW_IMMIGRATION_SERVICE,
                                ],
                            },
                            {
                                type: 'link',
                                label: 'File Requirements',
                                route: '/manual-booking-management/immigration-service/file-requirements',
                                permissions: [
                                    PermissionCode.VIEW_IMMIGRATION_SERVICE_FILE_REQUIREMENT,
                                ],
                            },
                            {
                                type: 'link',
                                label: 'Acknowledgements',
                                route: '/manual-booking-management/immigration-service/acknowledgements',
                                permissions: [
                                    PermissionCode.VIEW_IMMIGRATION_SERVICE_ACKNOWLEDGEMENT,
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                type: 'dropdown',
                label: 'Driving Permit',
                icon: 'directions_car',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.CREATE_DRIVING_PERMIT,
                    PermissionCode.VIEW_DRIVING_PERMIT,
                    PermissionCode.DELETE_DRIVING_PERMIT,
                    PermissionCode.UPDATE_DRIVING_PERMIT,
                    PermissionCode.CREATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                    PermissionCode.VIEW_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                    PermissionCode.DELETE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                    PermissionCode.UPDATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                    PermissionCode.CREATE_DRIVING_PERMIT_FILE_REQUIREMENT,
                    PermissionCode.VIEW_DRIVING_PERMIT_FILE_REQUIREMENT,
                    PermissionCode.DELETE_DRIVING_PERMIT_FILE_REQUIREMENT,
                    PermissionCode.UPDATE_DRIVING_PERMIT_FILE_REQUIREMENT,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Driving Permit List',
                        route: '/driving-permit-management/driving-permit-list',
                        permissions: [
                            PermissionCode.CREATE_DRIVING_PERMIT,
                            PermissionCode.VIEW_DRIVING_PERMIT,
                            PermissionCode.DELETE_DRIVING_PERMIT,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Acknowledgements',
                        route: '/driving-permit-management/acknowledgements',
                        permissions: [
                            PermissionCode.CREATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                            PermissionCode.VIEW_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                            PermissionCode.DELETE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                            PermissionCode.UPDATE_DRIVING_PERMIT_ACKNOWLEDGEMENT,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Requirements',
                        route: '/driving-permit-management/requirements',
                        permissions: [
                            PermissionCode.CREATE_DRIVING_PERMIT_FILE_REQUIREMENT,
                            PermissionCode.VIEW_DRIVING_PERMIT_FILE_REQUIREMENT,
                            PermissionCode.DELETE_DRIVING_PERMIT_FILE_REQUIREMENT,
                            PermissionCode.UPDATE_DRIVING_PERMIT_FILE_REQUIREMENT,
                        ],
                    },
                ],
            },
            {
                type: 'dropdown',
                label: 'Passport',
                icon: 'assignment',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_PASSPORT_APPLICATION_TYPE,
                    PermissionCode.CREATE_PASSPORT_APPLICATION_TYPE,
                    PermissionCode.UPDATE_PASSPORT_APPLICATION_TYPE,
                    PermissionCode.DELETE_PASSPORT_APPLICATION_TYPE,
                    PermissionCode.VIEW_PASSPORT_REQUIREMENT,
                    PermissionCode.CREATE_PASSPORT_REQUIREMENT,
                    PermissionCode.UPDATE_PASSPORT_REQUIREMENT,
                    PermissionCode.DELETE_PASSPORT_REQUIREMENT,
                    PermissionCode.VIEW_PASSPORT_ACKNOWLEDGEMENT,
                    PermissionCode.CREATE_PASSPORT_ACKNOWLEDGEMENT,
                    PermissionCode.UPDATE_PASSPORT_ACKNOWLEDGEMENT,
                    PermissionCode.DELETE_PASSPORT_ACKNOWLEDGEMENT,
                    PermissionCode.VIEW_PASSPORT_DFA_SITE,
                    PermissionCode.CREATE_PASSPORT_DFA_SITE,
                    PermissionCode.UPDATE_PASSPORT_DFA_SITE,
                    PermissionCode.DELETE_PASSPORT_DFA_SITE,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Application Types',
                        route: '/passport-management/application-types',
                        icon: 'category',
                        permissions: [
                            PermissionCode.VIEW_PASSPORT_APPLICATION_TYPE,
                            PermissionCode.CREATE_PASSPORT_APPLICATION_TYPE,
                            PermissionCode.UPDATE_PASSPORT_APPLICATION_TYPE,
                            PermissionCode.DELETE_PASSPORT_APPLICATION_TYPE,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Requirements',
                        route: '/passport-management/requirements',
                        icon: 'list_alt',
                        permissions: [
                            PermissionCode.VIEW_PASSPORT_REQUIREMENT,
                            PermissionCode.CREATE_PASSPORT_REQUIREMENT,
                            PermissionCode.UPDATE_PASSPORT_REQUIREMENT,
                            PermissionCode.DELETE_PASSPORT_REQUIREMENT,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Acknowledgements',
                        route: '/passport-management/acknowledgements',
                        icon: 'check_circle',
                        permissions: [
                            PermissionCode.VIEW_PASSPORT_ACKNOWLEDGEMENT,
                            PermissionCode.CREATE_PASSPORT_ACKNOWLEDGEMENT,
                            PermissionCode.UPDATE_PASSPORT_ACKNOWLEDGEMENT,
                            PermissionCode.DELETE_PASSPORT_ACKNOWLEDGEMENT,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'DFA Sites',
                        route: '/passport-management/dfa-sites',
                        icon: 'location_on',
                        permissions: [
                            PermissionCode.VIEW_PASSPORT_DFA_SITE,
                            PermissionCode.CREATE_PASSPORT_DFA_SITE,
                            PermissionCode.UPDATE_PASSPORT_DFA_SITE,
                            PermissionCode.DELETE_PASSPORT_DFA_SITE,
                        ],
                    },
                ],
            },
            {
                type: 'dropdown',
                label: 'Travel Packages',
                icon: 'luggage',
                userTypes: [UserType.ADMIN, UserType.AGENT],
                permissions: [
                    PermissionCode.VIEW_TOUR_PACKAGE,
                    PermissionCode.CREATE_TOUR_PACKAGE,
                    PermissionCode.UPDATE_TOUR_PACKAGE,
                    PermissionCode.DELETE_TOUR_PACKAGE,
                    PermissionCode.VIEW_TOUR_PACKAGE_BOOKING,
                    PermissionCode.UPDATE_TOUR_PACKAGE_BOOKING_STATUS,
                    PermissionCode.CANCEL_TOUR_PACKAGE_BOOKING,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Package List',
                        route: '/travel-packages/list',
                        permissions: [
                            PermissionCode.VIEW_TOUR_PACKAGE,
                            PermissionCode.CREATE_TOUR_PACKAGE,
                            PermissionCode.UPDATE_TOUR_PACKAGE,
                            PermissionCode.DELETE_TOUR_PACKAGE,
                        ],
                    },
                    {
                        type: 'link',
                        label: 'Analytics',
                        route: '/travel-packages/analytics',
                        userTypes: [UserType.ADMIN],
                        permissions: [PermissionCode.VIEW_TOUR_PACKAGE],
                    },
                ],
            },
            {
                type: 'dropdown',
                label: 'CMS',
                icon: 'article',
                userTypes: [UserType.ADMIN],
                permissions: [
                    PermissionCode.VIEW_CMS_POST,
                    PermissionCode.VIEW_CMS_CATEGORY,
                    PermissionCode.VIEW_FAQ,
                ],
                children: [
                    {
                        type: 'link',
                        label: 'Categories',
                        route: '/cms/categories',
                        icon: 'category',
                        permissions: [PermissionCode.VIEW_CMS_CATEGORY],
                    },
                    {
                        type: 'link',
                        label: 'Help Article',
                        route: '/cms/posts',
                        icon: 'article',
                        permissions: [PermissionCode.VIEW_CMS_POST],
                    },
                    {
                        type: 'link',
                        label: 'FAQs',
                        route: '/faq-management',
                        icon: 'help_outline',
                        permissions: [PermissionCode.VIEW_FAQ],
                    },
                ],
            },
        ],
    },
];
